export interface FormItem {
    type: string,
    itemId?: string,
    parentItemId?: string,
    label?: string,
    className?: string,
    hint?: string,
    placeholder?: string,
    maxLength?: number,
    order?: number,
    required?: boolean | string,
    valid?: boolean,
    visible?: boolean,
    disabled?: boolean,
    rules?: any,
    items?: Array<FormItem>,
    data?: any,
    value?: any
};
